import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core"

import {dashboard} from "@signals";
import {useCallback} from "react";
import routes from "Routes";

export default function DIPDashboardSelect({ options, ...props }) {

		const generateDict = (child, parentID) => ({
		key: child?.id,
		label: child?.title,
		value: child?.path,
		parent: parentID
	})

	const generateListDashboards = useCallback((routesList) => {
		return routesList.reduce((result, route) => {
			return result.concat((route?.children || []).map(child => generateDict(child, route.id)))
		}, []).filter(item => !!item.label && !!item.value)
	}, [])

    return <SelectSeeker
        options={generateListDashboards(routes)}
        label="Dashboard"
		placeholder="All dashboards"
		isClearable
		multiple
        value={dashboard.value}
        onChange={e => dashboard.value = e.target.value}
        {...props}
    />
}